import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../../constants/common'
import {
  ICON_COLOR,
  ICON_HEIGHT_54,
  IconSpinnerOverlay,
} from '../../../../Icon'
import { NotificationInline } from '../../../../Notification'
import {
  PdfViewer,
  PdfViewerFitMode,
  PdfViewerNavigation,
} from '../../../../PdfViewer'

import * as styles from './DocFlowMappingRecipientModalPreview.module.css'

function DocFlowMappingRecipientModalPreview({ hasPreviewError, previewFile }) {
  const { t } = useTranslation()

  return (
    <div className={styles.DocFlowMappingRecipientModalPreview}>
      {hasPreviewError ? (
        <NotificationInline
          className={styles.error}
          text={t('DocFlow.MappingRecipientModalPreviewNotAvailableKey')}
          type={NOTIFICATION_TYPE.error}
        />
      ) : previewFile ? (
        <PdfViewer
          singlePage
          Navigation={PdfViewerNavigation}
          className={styles.pdfViewer}
          file={previewFile}
          fitMode={PdfViewerFitMode.PageFit}
          navigationProps={{
            arrowButtonProps: { isGrey: true },
            buttonClassName: styles.navButton,
            leftButtonClassName: styles.navButtonLeft,
            rightButtonClassName: styles.navButtonRight,
          }}
          tools={EMPTY_LIST}
        />
      ) : (
        <IconSpinnerOverlay
          className={styles.loader}
          color={ICON_COLOR.SecondaryTextColor}
          size={ICON_HEIGHT_54}
        />
      )}
    </div>
  )
}

export default DocFlowMappingRecipientModalPreview
